import { Link as BaseInternalLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { ExternalLink as BaseExternalLink } from 'components/external-link';

const linkStyles = css`
  text-decoration: none;
  color: ${Styles.color.white};
  font-size: 1rem;

  cursor: pointer;

  &:hover {
    text-decoration: underline;
    color: ${Styles.color.white};
  }

  /* Override global outline color here for contrast ratio */
  :focus {
    outline-color: ${Styles.color.white};
  }
`;

export const InternalLink = styled(BaseInternalLink)`
  ${linkStyles}
`;

export const ExternalLink = styled(BaseExternalLink)`
  ${linkStyles}
`;

const horizontalLinkStyles = css`
  color: ${Styles.color.grey.four};
  font-size: 1rem;
  text-transform: capitalize;

  &:hover {
    color: ${Styles.color.grey.four};
  }
`;

export const HorizontalInternalLink = styled(InternalLink)`
  ${horizontalLinkStyles}
`;

export const HorizontalExternalLink = styled(ExternalLink)`
  ${horizontalLinkStyles}
`;

const highlightedLinkStyles = css`
  color: ${Styles.color.primary};

  &:hover {
    color: ${Styles.color.primary};
  }
`;

export const HighlightedInternalLink = styled(InternalLink)`
  ${highlightedLinkStyles}
`;

export const HighlightedExternalLink = styled(ExternalLink)`
  ${highlightedLinkStyles}
`;

const paddedLinkStyles = css`
  /* PLK currently doesn't have a notion of a padded link, but if they did, this is where it would go */
`;

export const PaddedInternalLink = styled(InternalLink)`
  ${paddedLinkStyles}
`;

export const PaddedExternalLink = styled(ExternalLink)`
  ${paddedLinkStyles}
`;
